import { render, staticRenderFns } from "./IconChoose.vue?vue&type=template&id=75ff59aa&"
import script from "./IconChoose.vue?vue&type=script&lang=js&"
export * from "./IconChoose.vue?vue&type=script&lang=js&"
import style0 from "./IconChoose.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports